import React, { useEffect } from "react"
import PropTypes from "prop-types"

import ServiceBrand from "./shared/service_brand"
import { useBgColorContext } from "./context"
import { headerColored } from "./utils/container_background_color"
import { pluralizeStepType } from "shared/lib/utils"
import { trackClickServiceStepSelected } from "./utils/telemetry"

import "./step_selector.scss"

export default function StepSelector({
  onStepSelect,
  service,
  selectedSteps,
  steps,
  stepType,
}) {
  const bgColor = useBgColorContext()

  useEffect(() => {
    headerColored(bgColor)

    return () => {
      headerColored("initial")
    }
  }, [bgColor])

  const identifiersFromSelectedSteps = selectedSteps.map(
    step => step.full_module_name
  )

  const stepsAvailables = steps
    .filter(
      step => !identifiersFromSelectedSteps.includes(step.full_module_name)
    )
    .sort((a, b) => a["weight"] - b["weight"])

  const tile = step => {
    const onStepClicked = () => {
      trackClickServiceStepSelected({
        stepIdentifier: step.full_module_name,
        stepType,
      })
      onStepSelect({ ...step, service })
    }

    return (
      <li
        key={step.id}
        style={{ backgroundColor: service.brand_color }}
        role="listitem"
        onClick={onStepClicked}
      >
        <a title={`Choose ${stepType}: ${step.name}`}>
          <span styleName="title">{step.name}</span>
          <span styleName="description">{step.description}</span>
        </a>
      </li>
    )
  }

  return (
    <div styleName="step-selector">
      <section styleName="brand" style={{ backgroundColor: bgColor }}>
        <ServiceBrand title={service.name} image={service.image} />
      </section>
      {stepsAvailables.length > 0 ? (
        <ul role="list">{stepsAvailables.map(step => tile(step))}</ul>
      ) : (
        <span styleName="empty-list">
          You have selected all {pluralizeStepType(stepType)} from this service
        </span>
      )}
    </div>
  )
}

StepSelector.propTypes = {
  onStepSelect: PropTypes.func.isRequired,
  service: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  selectedSteps: PropTypes.array,
  stepType: PropTypes.oneOf(["trigger", "action", "query"]).isRequired,
}
